// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1y-Ub","content":"Consent_content__1Bdwy","footer":"Consent_footer__b9A9e"};